module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-09-11 at 16.21.48.e713bd2f.png";